import Vue from 'vue'
import Vuex from 'vuex'
import Actions from '@/store/actions'
import Mutations from '@/store/mutations'
import Store from '@/store/modules/store'
import Util from '@/store/modules/util'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    loading: false,
    access_token: localStorage.getItem('user_token'),
    user: JSON.parse(localStorage.getItem('user_info'))
  },
  getters: {
    modules: state => {
      return state.user.tenant.modules !== undefined
        ? state.user.tenant.modules
        : null
    }
  },
  mutations: {
    loading(state, payload) {
      state.loading = !state.loading
    },
    loadingFail(state) {
      state.loading = false
    },
    AUTH_USER(state, payload) {
      localStorage.setItem('user_token', payload.access_token)
      localStorage.setItem('user_info', JSON.stringify(payload.user))
      state.access_token = payload.access_token
      state.user = payload.user
    },
    USER_INFO(state, payload) {
      state.user = payload
    },
    ...Mutations
  },
  actions: {
    ...Actions
  },
  modules: {
    store: Store,
    util: Util
  },
  plugins: [createPersistedState()]
})
